import React from 'react'
import { PiSubtitles } from "react-icons/pi";
import { MdOutlineSubject } from "react-icons/md";
import { GrAttachment } from "react-icons/gr";
import { handleCloseReportModal } from '../../state/reportSlice'
import { useDispatch } from 'react-redux';



const ReportInfo = ({report}) =>{
    const dispatch = useDispatch()

    const handleClose = ()=>{
        dispatch(handleCloseReportModal())
    }

  return (
    <div className='todo__info' onClick={handleClose}>
        <div className="todo__info-content" onClick={(e)=>e.stopPropagation()}>
            <button 
            onClick={handleClose}
            className="todo__info-btn">
                <i class='bx bx-x'></i>
            </button>
            {
                report?.attachment && <img src={`https://backend.aspomportal.com/upload/${report?.attachment}`} 
                alt="" className="todo__info-img" />
            }
            <h2 className="todo__info-title">
                <PiSubtitles size={25}/>
                {report?.title}
            </h2>
            <div className="todo__info-item">
                <h4 className="todo__info-title">
                    <MdOutlineSubject size={20}/>
                    Description
                </h4>
                <div className="todo__info-desc"
                dangerouslySetInnerHTML={{__html: report?.description}}>
                </div>
            </div>
            {
                report?.attachment && (
                    <div className="todo__info-item">
                        <h4 className="todo__info-title">
                            <GrAttachment />
                            Attachment
                        </h4>
                        <div className="todo__info-attachment">
                            <img src={`https://backend.aspomportal.com/upload/${report?.attachment}`} alt=""
                            className="todo__info-attachment_img" />
                            <a href={`https://backend.aspomportal.com/upload/${report?.attachment}`} 
                            className="todo__attachment" download>Download</a>
                        </div>
                    </div>
                )
            }
        </div>
    </div>
  )
}

export default ReportInfo